<script setup>
import { ref } from "vue";
import DefaultLayout from "./layouts/DefaultLayout.vue";
import { useCompanyStore } from "@/stores/company";
import { useDocumentsStore } from "@/stores/documents";
import useValidation from "@/utils/helpers/validations";

const url = ref("");
const documentsStore = useDocumentsStore();
const { checkApkUrlValidation } = useValidation();
let isValidUrl = ref(true);

const company_id = useCompanyStore().companyId;
// eslint-disable-next-line no-unused-vars
const validUrl = () => {
  isValidUrl.value = true;
  if (url.value.length > 0) {
    isValidUrl.value = checkApkUrlValidation(url.value);
    return isValidUrl.value;
  }
};

let file = ref(null);
let appFile = ref(null);
let fileError = ref(false);
const isSubmitting = ref(false);

const resetUploadedFileData = () => {
  file.value = null;
  appFile.value.value = null;
  fileError.value = false;
};

// eslint-disable-next-line no-unused-vars
const onSubmit = async () => {
  isSubmitting.value = true;
  let formData = new FormData();
  !!file.value && formData.append("file", file.value);
  !!url.value && formData.append("url", url.value);
  formData.append("company_id", company_id);
  formData.append("type", file.value ? "document" : "url");
  const hasFile = !!file.value;

  await documentsStore
    .updateAiData({
      formData,
      hasFile,
    })
    .finally(() => {
      isSubmitting.value = false;
      resetUploadedFileData();
    });
};
</script>

<template>
  <DefaultLayout>
    <div class="auth-card m-auto">
      <h3 class="text-center mb-4">Update Data</h3>
      <!-- Remove the upload documents form -->
    </div>
  </DefaultLayout>
</template>

<style>
.pies-container {
  max-width: 100%;
  position: relative;
  border-radius: 8px;
  background: #fff;
}

.pies-container > .pie {
  max-width: 100%;
  height: 400px;
  padding: 10px;
}

#chart {
  height: 410px;
  padding: 10px;
  max-width: 100%;
  width: auto;
  margin: auto;
  border-radius: 8px;
  background: #fff;
}

.textChart {
  font-size: 20px !important;
  background-color: black !important;
}
input:disabled {
  cursor: not-allowed;
}
</style>
